import { fetchCoGuardianActivities } from '@/services/get-co-guardian-activities';
import { useQuery } from '@tanstack/react-query';

export const coGuardianActivitiesKeys = {
  all: ['co-guardian-activities'] as const,
  list: (playerId?: string, guardianUid?: string) =>
    [...coGuardianActivitiesKeys.all, playerId ?? null, guardianUid ?? null] as const,
};

/**
 * A co-guardian's recent activities scoped to a specific player (BR-01), from
 * GET `/api/v1/guardians/me/players/{playerId}/guardians/{guardianUid}/activities`
 * (newest first). Gated on both ids.
 */
export function useCoGuardianActivitiesQuery(playerId?: string, guardianUid?: string) {
  return useQuery({
    queryKey: coGuardianActivitiesKeys.list(playerId, guardianUid),
    queryFn: () => fetchCoGuardianActivities(playerId as string, guardianUid as string),
    enabled: Boolean(playerId) && Boolean(guardianUid),
  });
}
